import {Component, OnInit, Input, Inject} from '@angular/core';
import {DataGeneratorService} from "@/angular-blocworx/components/fields/data-generator/data-generator.service";
import {ScanStationService} from "@/angular-blocworx/components/scanStation/scan-station-service";
import {BlocworxSharedService} from "@/angular-blocworx/components/shared/blocworx-shared.service";
import {Configuration} from "@/angular-blocworx/components/configuration/services/configuration.service";
import * as angular from "angular";
import {DomSanitizer} from '@angular/platform-browser';
import {isEqual} from 'lodash';
import {GridService} from "@/angular-blocworx/components/grid/grid.service";
import {Subscription} from 'rxjs';
import {ResultsBoxService} from "@/angular-blocworx/components/fields/results-box/results-box.service";
import {MatDialog} from '@angular/material/dialog';
import {RecurringDataDialogComponent} from '@/angular-blocworx/components/fields/data-generator/recurring-data-dialog.component';
import {OverlayContainer} from '@angular/cdk/overlay';

@Component({
    selector: 'data-generator-in-form',
    templateUrl: 'angular-blocworx/components/fields/data-generator/templates/in-form.html',
    styleUrls: ['angular-blocworx/components/fields/data-generator/data-generator.component.scss'],
})

export class DataGeneratorInForm implements OnInit {

    @Input() field;
    @Input() scanStation;
    @Input() fc;
    loadingData: Array<any> = [];
    generatingData: Array<any> = [];
    private openDialogsCount = 0;




    constructor(
        @Inject(DataGeneratorService) private dataGeneratorService: DataGeneratorService,
        @Inject(ScanStationService) private scanStationService: ScanStationService,
        @Inject(BlocworxSharedService) private blocworxSharedService: BlocworxSharedService,
        @Inject(Configuration) private configuration: Configuration,
        @Inject(DomSanitizer) private sanitizer: DomSanitizer,
        @Inject(GridService) private gridService: GridService,
        @Inject(ResultsBoxService) private resultsBoxService: ResultsBoxService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(OverlayContainer) private overlayContainer: OverlayContainer,

    ) {

    }


    /**
     * Opens the recurrence-rule dialog
     */
    openRecurringDataDialog(): void {

        let primaryDateField = this.scanStation.scanStationObj.scanStationFieldIdsToField[this.field.primaryDateFieldId];

        const dialogRef = this.dialog.open(RecurringDataDialogComponent, {
            data: {
                field: this.field,
                dataToAdd: this.scanStation.scanStationObj.dataToAdd,
                primaryDateField: primaryDateField,
                scanStationObj: this.scanStation.scanStationObj
            }
        });

        this.overlayContainer.getContainerElement().classList.add('blocworx-popup', 'recurring-data-popup');

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.scanStation.scanStationObj.recurringData = result;
                this.scanStation.scanStationObj.recurringData.primaryDateField = primaryDateField;
                this.scanStation.scanStationObj.recurringData.recurringDataField = this.field;
            }
            this.openDialogsCount--;
            if (this.openDialogsCount <= 0) {
                this.overlayContainer.getContainerElement().classList.remove('blocworx-popup', 'recurring-data-popup');
                this.openDialogsCount = 0;
            }
        });
    }

    onApplyChangesToggle(value: any): void {
        const applyChangesMode = parseInt(value, 10);
        
        let primaryDateField = this.scanStation.scanStationObj.scanStationFieldIdsToField[this.field.primaryDateFieldId];
        
        if (applyChangesMode === 1) {
            // Apply changes to ALL recurring data
            this.scanStation.scanStationObj.recurringData.primaryDateField = primaryDateField;
            this.scanStation.scanStationObj.recurringData.recurringDataField = this.field;
        } else if (applyChangesMode === 2) {
            // Apply changes to THIS and ALL FUTURE events
            this.scanStation.scanStationObj.recurringData.primaryDateField = primaryDateField;
            this.scanStation.scanStationObj.recurringData.recurringDataField = this.field;
            // Flag to indicate we're creating a new series from this point forward
            this.scanStation.scanStationObj.recurringData.createNewSeriesFromThisEvent = true;
        } else {
            // Do NOT apply changes (value = 0)
            this.scanStation.scanStationObj.recurringData.primaryDateField = null;
            this.scanStation.scanStationObj.recurringData.recurringDataField = null;
            this.scanStation.scanStationObj.recurringData.createNewSeriesFromThisEvent = false;
        }
    }

    async ngOnInit() {

    }



    async ngAfterViewInit() {


    }

    loading = (fileName: string) => {
        let fileArray = fileName.replace(" ", "_");
        return this.loadingData[fileArray];
    }

    ngOnDestroy() {

    }

    async triggerDataGeneratorAction() {
        try {
            // Check if confirmation is required
            if (this.field.askUserConfirmation == 1) {
                const confirmationText = this.field.confirmationPopupText || 'Are you sure you want to proceed?';
                const userConfirmed = confirm(confirmationText);

                if (!userConfirmed) {
                    return; // Exit without proceeding
                }
            }
            this.generatingData[this.field.id] = true;
            // Prepare local field data object
            let localFieldData = {};


            // Get local fields from matching pairs (localFieldMatchingFieldPairs)
            if (this.field.localFieldMatchingFieldPairs) {
                const localFieldMatchingPairs = Object.values(this.field.localFieldMatchingFieldPairs);
                localFieldMatchingPairs.forEach((pair: any) => {
                    // Find the local field by ID
                    const localField = this.scanStation.scanStationObj.scanStationFields.find(field =>
                        field.id.toString() === pair.localFieldId.toString()
                    );

                    if (localField && localField.field_slug) {
                        // Get the value from dataToAdd using field_slug
                        const fieldValue = this.scanStation.scanStationObj.dataToAdd[localField.field_slug];
                        localFieldData[localField.field_slug] = {
                            fieldId: localField.id,
                            fieldSlug: localField.field_slug,
                            value: fieldValue,
                        };
                    }
                });
            }


            // Get local fields from local->destination mapping (localDestinationFieldMatchingPairs)
            if (this.field.localDestinationFieldMatchingPairs) {

                const localDestinationFieldMatchingPairs = Object.values(this.field.localDestinationFieldMatchingPairs);
                localDestinationFieldMatchingPairs.forEach((pair: any) => {
                    // Find the local field by ID (sourceFieldId in this case refers to local field)
                    const localField = this.scanStation.scanStationObj.scanStationFields.find(field =>
                        field.id.toString() === pair.sourceFieldId.toString()
                    );

                    if (localField && localField.field_slug) {
                        // Get the value from dataToAdd using field_slug
                        const fieldValue = this.scanStation.scanStationObj.dataToAdd[localField.field_slug];
                        localFieldData[localField.field_slug] = {
                            fieldId: localField.id,
                            fieldSlug: localField.field_slug,
                            value: fieldValue,
                        };
                    }
                });
            }

            // Call the service method
            const response = await this.dataGeneratorService.triggerDataGeneratorAction(
                this.field.id,
                localFieldData
            );
            
            this.generatingData[this.field.id] = false;
			
			if(this.field.triggerActionsAfterCopying == 1) {
				// we need to give it some sort of value so the actions/rules will get triggered
				this.scanStation.scanStationObj.dataToAdd[this.field.field_slug] = 'Data Denerator Field';
				await this.scanStation.getRules('no-event', this.field.id, this.field.special_field_key, this.scanStation.scanStationObj.dataToAdd[this.field.field_slug], this.field.fieldIndex, this.field.field_slug);
			}

            await this.scanStation.updateDropDownsRadiosAutoCompletesForAllFields(this.field);

            if(this.field.fieldsToRefreshAfterCompletion != null) {
                await this.resultsBoxService.callTriggerResultsBoxViaForcedRefreshList(this.field.fieldsToRefreshAfterCompletion);            }

            return response;

        } catch (error) {
            console.error('Error triggering data generator action:', error);
            this.generatingData[this.field.id] = false;
            throw error;
        }
    }

}
